import { FC, ReactElement } from "react";

import { Badge } from "../catalyst/Badge";
import { ProgressBarProps } from "../ProgressBar";

export const StepIndicator: FC<ProgressBarProps> = ({
  steps,
}): ReactElement => {
  return (
    <div className="flex items-center space-x-2 text-sm">
      {steps.map((step, index) => {
        const isCurrentStep = step.status == "current";
        const isPastStep = step.status == "complete";

        return (
          <div className="flex items-center" key={step.id}>
            <Badge
              className={`h-6 w-6 items-center justify-center rounded-full p-0 text-xs ${
                isCurrentStep || isPastStep
                  ? "bg-emerald-600 text-white dark:bg-emerald-600 dark:text-white"
                  : "bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400"
              }`}
              color={isCurrentStep || isPastStep ? "emerald" : "zinc"}
            >
              {index + 1}
            </Badge>

            {index < steps.length - 1 && (
              <div
                className={`mx-2 h-0.5 w-8 ${
                  isPastStep ? "bg-emerald-600" : "bg-gray-200 dark:bg-gray-700"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
